/* global u */

/**
 * Print window on button click.
 */
export default function() {
  const $print_button = u('.js-print-button');
  $print_button.on('click', () => {
    window.print();
  });
};
